// extracted by mini-css-extract-plugin
export default {"painelConsultaGruposChave":"Consultar_painelConsultaGruposChave__bXVjv"};